import api from '../base';
import {
  AssignableRoles,
  ManagedUser,
  UserCreateRequest,
  UserPartnersUpdateRequest,
  UserPasswordUpdateRequest,
  UserRolesUpdateRequest,
  UserSearchRequest,
} from './userManagementApiTypes';
import {
  createMockCreatedUser,
  createMockUserWithPartners,
  createMockUserWithRoles,
  findMockUsers,
  mockAssignableRoles,
} from './userManagementMocks';

const BASE_PATH = 'management/users';

export async function searchUsers(
  request: UserSearchRequest,
  signal?: AbortSignal,
): Promise<ManagedUser[]> {
  return api.post<ManagedUser[]>(`${BASE_PATH}/search`, request, { signal }).then(response => response.data);
}

api.mock.onPost(`${BASE_PATH}/search`).reply(config => [200, findMockUsers(JSON.parse(config.data))]);

export async function getAssignableRoles(): Promise<AssignableRoles> {
  return api.get<AssignableRoles>(`${BASE_PATH}/roles/assignable`).then(response => response.data);
}

api.mock.onGet(`${BASE_PATH}/roles/assignable`).reply(200, mockAssignableRoles);

export async function createUser(request: UserCreateRequest): Promise<ManagedUser> {
  return api.post<ManagedUser>(BASE_PATH, request).then(response => response.data);
}

api.mock.onPost(BASE_PATH).reply(config => [201, createMockCreatedUser(JSON.parse(config.data))]);

export async function updateUserPartners(
  userId: number,
  request: UserPartnersUpdateRequest,
): Promise<ManagedUser> {
  return api.put<ManagedUser>(`${BASE_PATH}/${userId}/partners`, request).then(response => response.data);
}

api.mock.onPut(new RegExp(`${BASE_PATH}/\\d+/partners`))
  .reply(config => [200, createMockUserWithPartners(config.url, JSON.parse(config.data))]);

export async function updateUserRoles(
  userId: number,
  request: UserRolesUpdateRequest,
): Promise<ManagedUser> {
  return api.put<ManagedUser>(`${BASE_PATH}/${userId}/roles`, request).then(response => response.data);
}

api.mock.onPut(new RegExp(`${BASE_PATH}/\\d+/roles`))
  .reply(config => [200, createMockUserWithRoles(config.url, JSON.parse(config.data))]);

export async function updateUserPassword(
  userId: number,
  request: UserPasswordUpdateRequest,
): Promise<void> {
  return api.post<void>(`${BASE_PATH}/${userId}/password`, request).then(response => response.data);
}

api.mock.onPost(new RegExp(`${BASE_PATH}/\\d+/password`)).reply(204);
